/**
 * Default jobs per SRP page. Shared by the client search (SearchContext), the SSR search
 * (pages/index/+data.ts), and the static shell so paginated URLs, SSR HTML, and
 * hydrated results always agree on page boundaries when the user hasn't chosen otherwise.
 */
export const SRP_HITS_PER_PAGE = 24;

/** User-selectable "results per page" values (see ResultsPerPageSelector). */
export const SRP_HITS_PER_PAGE_OPTIONS: readonly number[] = [24, 48, 96];

export function isValidSrpHitsPerPage(value: unknown): value is number {
  return typeof value === 'number' && Number.isFinite(value) && SRP_HITS_PER_PAGE_OPTIONS.includes(value);
}
